export const APPOINTMENT_SUBMITTED_KEY = 'appointmentSubmitted';
export const APPOINTMENT_SUBMITTED_VALUE = 'true';
